import React from "react";

// İKON LİSTESİNİ GÜNCELLİYORUZ: FaShareAlt'ı ekliyoruz
import { FaShareAlt } from "react-icons/fa";

import "./TeamSection.scss";
import hekim1 from "../../assets/images/cerceveli-hekim1.png";
import hekim2 from "../../assets/images/cerceveli-hekim2.png";
import hekim3 from "../../assets/images/cerceveli-hekim3.png";
import hekim4 from "../../assets/images/cerceveli-hekim4.png";

const teamData = [
  {
    image: hekim1,
    name: "hekim1",
    title: "Kurucu Veteriner Hekim",
    social: { url: "#" },
  },
  {
    image: hekim2,
    name: "hekim2",
    title: "Veteriner Teknikeri",
    social: { url: "#" },
  },
  {
    image: hekim3,
    name: "hekim3",
    title: "Veteriner Hekim",
    social: { url: "#" },
  },
  {
    image: hekim4,
    name: "hekim4",
    title: "Veteriner Teknikeri",
    social: { url: "#" },
  },
];

const TeamMemberCard = ({ image, name, socia, title }) => {
  return (
    <div className="team-member-card">
      <div className="member-image-wrapper">
        <img src={image} alt={name} className="member-composite-image" />

        {/* <a
          href={social.url}
          className="social-icon-wrapper"
          target="_blank"
          rel="noopener noreferrer"
        >
          {/* DEĞİŞİKLİK: <img> yerine icon component'ini kullanıyoruz */}
        {/* <FaShareAlt /> */}
        {/* </a> */}
      </div>
      <div className="member-info">
        <h3 className="member-title">{title}</h3>
      </div>
    </div>
  );
};

const TeamSection = () => {
  // ... (Bu kısım aynı kalabilir) ...
  return (
    <div className="team-section-container">
      <div className="team-grid">
        {teamData.map((member, index) => (
          <TeamMemberCard
            key={index}
            image={member.image}
            name={member.name}
            social={member.social}
            title={member.title}
          />
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
